import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { StorageService } from 'app/storageprovider';
import { DnDialogService } from 'app/_modules/dn-dialog/dn-dialog.service';
import { ConfigService } from 'app/_service/config/config.service';
import { ToastService } from 'app/_service/toast/toast.service';
import { UserService } from 'app/_service/user/user.service';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Injectable()
export class AuthGuard implements CanActivate {
    user: any;
    mustLogin = false;
    constructor(
        private router: Router,
        private _dnDialogService: DnDialogService,
        private _userService: UserService,
        private configService: ConfigService,
        private _toastService: ToastService,
        private _storage: StorageService,
    ) {

    }

    readState() {

    }

    canActivate(): Observable<boolean> {
        return this.configService.config$.pipe(
            take(1),
            map(config => {
                const token = this._storage.GetSessionData("token");
                this.mustLogin = config.mustLogin;
                if (this._userService.user.id > 0 || !this.mustLogin || token) {
                    return true;
                } else {
                    this.router.navigateByUrl('/');
                    this._dnDialogService.close('login-required-dialog');
                    this._userService.showLoginDialog(true);
                    this._toastService.showBlackToast('您需要登录才能继续');
                    return false;
                }
            })
        )
    }
}
